import React from 'react';
import {connect} from 'react-redux';

// Components
import Header from 'Components/common/Header';
import GodMap from 'Components/host/GodMap';
import {APILoader} from '@uiw/react-amap';
import 'cross-fetch/polyfill';

// Actions
import {setShipmentsSource, setCurrentShipmentId} from 'Actions/host';
import {T} from 'Actions/translate'; // Icons
import {Refresh} from '@material-ui/icons';
import util from 'Utils/commonUtil';

class ClockedSigned extends React.Component {
    pager = {
        page: 0,
        length: 10,
        total: 0,
        pageTotal: 9999999999999999999999999,
    };

    state = {
        listLoaded: true,
        showMap: false,
        hostPosition: [],
    };

    componentWillMount() {
        this.loadGodMap();
    }

    loadGodMap = () => {
        // this.getLocation();
        window.scrollTo(0, 0);

        this.setState({
            showMap: true,
        });
    };

    getLocation = () => {
        const options = {
            method: 'GET',
        };

        return new Promise((resolve, reject) => {
            fetch(
                'http://restapi.amap.com/v3/ip?key=0f4eb80f2e7d1a93008bf1d666caedce',
                options,
            )
                .then((res) => {
                    if (res.ok) {
                        res.text().then((data) => {
                            const detail = JSON.parse(data);
                            this.setState({
                                city: detail.city,
                                adcode: detail.adcode,
                            });
                        });
                    }
                })
                .catch((res) => {
                    console.log(res.status);
                });
        });
    };

    goBack = () => {
        this.props.setShipmentsSource({$set: true});
        this.props.setCurrentShipmentId({
            $set: this.getShipmentItemInfor().shipments[0].id,
        });
        this.props.history.goBack();
    };

    goClickedSigned = () => {
        this.setState({
            showMap: true,
        });
    };

    refreshGodMap = () => {
        // if (this.props.hostPunchMap !== '{}') {
        //     console.log(this.props.hostPunchMap);
        //     this.props.hostPunchMap.destroy();
        // }
        this.apiLoaderMap();
    };

    getShipmentItemInfor = () => {
        let shipmentItem = undefined;
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            shipmentItem = routerState.shipmentItem;
        }
        return shipmentItem;
    };

    apiLoaderMap = () => {
        return (
            <APILoader akay="0f4eb80f2e7d1a93008bf1d666caedce">
                <GodMap
                    shipmentItem={this.getShipmentItemInfor()}
                    onPunchSuccess={this.goBack}
                />
            </APILoader>
        );
    };

    render() {
        const {listLoaded, showMap, hostPosition, clockCommentsFlg} =
            this.state;

        return (
            <div className="clicked-signed-container">
                <Header
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <div className="clicked-signed-header">
                        <h3 className="header-title">
                            {T('user_center_punch_signed')}
                        </h3>
                    </div>
                </Header>
                <div className="shipment-punch-container">
                    {/* <div
                        className="refresh-map-area"
                        onClick={() => {
                            this.refreshGodMap();
                        }}>
                        <Refresh className="icon" />
                        <div>{T('shippment_refresh_map')}</div>
                    </div> */}
                    {showMap ? this.apiLoaderMap() : null}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host, localData} = state;
    return {
        localData,
        yourMassageList: host.yourMassageList,
        hostPunchMap: host.hostPunchMap,
    };
};

const mapDispatchToProps = {
    setShipmentsSource,
    setCurrentShipmentId,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClockedSigned);
